// extracted by mini-css-extract-plugin
export default {"Wrapper":"Layout_Wrapper__wntIa","main-content":"Layout_main-content__3yDo5","nav-hide":"Layout_nav-hide__72Vi2","children":"Layout_children__Vk97K"};